// Fix for sticky header on collection pages with filters
(function() {
  'use strict';
  // Wait for the DOM and theme to be ready
  document.addEventListener('DOMContentLoaded', function() {
    // Small delay to ensure theme JS has run
    setTimeout(function() {
      window.addEventListener('scroll', function() {
        const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
        if (scrollPosition > 50) {
          document.body.classList.add('has-scrolled');
          // You can send an analytics event here
        } else {
          document.body.classList.remove('has-scrolled');
          // You can send an analytics event here
        }
      });
    }, 100);
  });

})();